"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreferenceTemplate = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactHooks = require("@trycourier/react-hooks");

var _Status = require("./Status");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var StyledItem = _styledComponents["default"].div.withConfig({
  displayName: "PreferenceTemplate__StyledItem",
  componentId: "e8mhi3-0"
})(["border-bottom:1px solid #dadce0;padding:10px;margin-top:6px;background:white;border-radius:4px;color:#333;.template-name{font-size:14px;white-space:nowrap;text-overflow:ellipsis;width:100%;margin-bottom:6px;font-weight:bold;}"]);

var PreferenceTemplate = function PreferenceTemplate(_ref) {
  var _recipientPreference$;

  var preferenceTemplate = _ref.preferenceTemplate,
      recipientPreference = _ref.recipientPreference,
      routingOptions = _ref.routingOptions,
      customizeDeliveryChannel = _ref.customizeDeliveryChannel;

  var _usePreferences = (0, _reactHooks.usePreferences)(),
      updateRecipientPreferences = _usePreferences.updateRecipientPreferences;

  var handleOnPreferenceChange = function handleOnPreferenceChange(newPreferences) {
    updateRecipientPreferences(_objectSpread({
      templateId: preferenceTemplate.templateId
    }, newPreferences));
  };

  if (!preferenceTemplate) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(StyledItem, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "template-name"
  }, preferenceTemplate.templateName), /*#__PURE__*/_react["default"].createElement(_Status.StatusPreference, {
    value: (preferenceTemplate === null || preferenceTemplate === void 0 ? void 0 : preferenceTemplate.defaultStatus) === "REQUIRED" ? "REQUIRED" : (_recipientPreference$ = recipientPreference === null || recipientPreference === void 0 ? void 0 : recipientPreference.status) !== null && _recipientPreference$ !== void 0 ? _recipientPreference$ : preferenceTemplate === null || preferenceTemplate === void 0 ? void 0 : preferenceTemplate.defaultStatus,
    onPreferenceChange: handleOnPreferenceChange,
    templateId: preferenceTemplate.templateId,
    routingOptions: routingOptions,
    customizeDeliveryChannel: customizeDeliveryChannel
  }));
};

exports.PreferenceTemplate = PreferenceTemplate;